import additionalProducts from "./additionalProducts.json";
import calculation from "./calculation.json";
import chi from "./chi.json";
import contactData from "./contactData.json";
import common from "./common.json";
import creditCheck from "./creditCheck.json";
import customRouter from "./customRouter.json";
import documentUpload from "./documentUpload.json";
import emailConsent from "./emailConsent.json";
import emailValidation from "./emailValidation.json";
import error from "./error.json";
import expired from "./expired.json";
import financialData from "./financialData.json";
import footer from "./footer.json";
import legitimation from "./legitimation.json";
import login from "./login.json";
import marketingConsent from "./marketingConsent.json";
import paymentData from "./paymentData.json";
import personalData from "./personalData.json";
import postIdent from "./postIdent.json";
import privacyConsent from "./privacyConsent.json";
import professionalData from "./professionalData.json";
import shoppingCart from "./shoppingCart.json";
import spinnerModal from "./spinnerModal.json";
import summary from "./summary.json";
import tileSelection from "./tileSelection.json";
import wizard from "./wizard.json";

export const i18n = {
  additionalProducts,
  calculation,
  chi,
  contactData,
  common,
  creditCheck,
  customRouter,
  documentUpload,
  emailConsent,
  emailValidation,
  error,
  expired,
  financialData,
  footer,
  legitimation,
  login,
  marketingConsent,
  paymentData,
  personalData,
  postIdent,
  privacyConsent,
  professionalData,
  shoppingCart,
  spinnerModal,
  summary,
  tileSelection,
  wizard,
};
